var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99 5.625H20.01L22.1725 3.895C22.9088 3.3075 23.1838 2.35375 22.8725 1.46375C22.5613 0.57375 21.7525 0 20.8125 0H9.1875C8.2475 0 7.43875 0.575 7.1275 1.46375C6.81625 2.3525 7.09125 3.3075 7.82625 3.89375L9.99 5.625Z",
    fill: "#FFBB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1813 7.5H9.81875C6.405 10.8512 3.75 16.7312 3.75 21.5625C3.75 25.7612 5.9725 30 10.9375 30H19.375C23.6162 30 26.25 26.7663 26.25 21.5625C26.25 16.7312 23.595 10.8512 20.1813 7.5ZM14.525 17.8125H15.475C16.9362 17.8125 18.125 19.0013 18.125 20.4625C18.125 21.7763 17.1775 22.8575 15.9375 23.0775V24.0613C15.9375 24.5788 15.5175 24.9988 15 24.9988C14.4825 24.9988 14.0625 24.5788 14.0625 24.0613V23.125H12.8125C12.295 23.125 11.875 22.705 11.875 22.1875C11.875 21.67 12.295 21.25 12.8125 21.25H15.475C15.9025 21.25 16.25 20.9025 16.25 20.475C16.25 20.035 15.9025 19.6875 15.475 19.6875H14.525C13.0638 19.6875 11.875 18.4987 11.875 17.0375C11.875 15.7238 12.8225 14.6425 14.0625 14.4225V13.4375C14.0625 12.92 14.4825 12.5 15 12.5C15.5175 12.5 15.9375 12.92 15.9375 13.4375V14.375H17.1875C17.705 14.375 18.125 14.795 18.125 15.3125C18.125 15.83 17.705 16.25 17.1875 16.25H14.525C14.0975 16.25 13.75 16.5975 13.75 17.025C13.75 17.465 14.0975 17.8125 14.525 17.8125Z",
    fill: "#FFBB38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTag);
export default __webpack_public_path__ + "static/media/money-tag.5b96de268660386ced17713517757aaa.svg";
export { ForwardRef as ReactComponent };